import { render } from "./SidebarList.vue?vue&type=template&id=834c62ee"
import script from "./SidebarList.vue?vue&type=script&lang=js"
export * from "./SidebarList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__